import React, { Component } from "react";
import PropTypes from "prop-types";
import BasePage from "../../../components/Page/BasePage";
import SideMenu from "../../../components/Menu/SideMenu";
import Knowlege from "../../../components/knowlege/Knowlege";
import menu from "../../../menu";
import { Scrollbars } from "react-custom-scrollbars";

import $ from "jquery";

class KnowlegePage extends BasePage {
  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.timer = {};

    this.changeTitle(this.props);
  }

  componentWillMount() {
    this.scrollToRightPlace(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.changeTitle(nextProps);
    this.scrollToRightPlace(nextProps);
  }

  componentWillUnmount() {
    if (this.timer.timerID !== undefined) {
      clearTimeout(this.timer.timerID);
    }
  }

  changeTitle(props) {
    var notFound = true;
    $("meta[name=description]").remove();
    if (props.routeParams.article === undefined) {
      if (props.routeParams.section.toLowerCase().indexOf("overview") === 0) {
        document.title = props.routeParams.section;
      } else {
        document.title = props.routeParams.section + " Overview";
      }

      for (var i = 0; i < menu.length; i++) {
        if (
          menu[i].section.toLowerCase() ===
          props.routeParams.section.toLowerCase()
        ) {
          notFound = false;
          $("head").append(
            '<meta name="description" content="' + menu[i].description + '">'
          );
        }
      }
    } else {
      for (var i = 0; i < menu.length; i++) {
        if (
          menu[i].section.toLowerCase() ===
          props.routeParams.section.toLowerCase()
        ) {
          for (var a = 0; a < menu[i].menu.length; a++) {
            if (menu[i].menu[a].heading !== true) {
              if (
                menu[i].menu[a].link.toLowerCase() ===
                props.routeParams.article.toLowerCase()
              ) {
                document.title =
                  props.routeParams.section + " " + menu[i].menu[a].title;
                notFound = false;
                $("head").append(
                  '<meta name="description" content="' +
                    menu[i].menu[a].description +
                    '">'
                );
              }
            }
          }
        }
      }
    }
    if (notFound) {
      this.timer.changeTimerID = setTimeout(e => {
        this.context.router.push("not_found");
      }, 250);
    }
  }

  scrollToRightPlace(props) {
    $("html").scrollTop(0);
    if (props.routeParams.article === undefined) {
      this.timer.changeTimerID = setTimeout(() => {
        if (window.location.href.indexOf("#") !== -1) {
          try {
            $("html").scrollTop(
              $("#" + window.location.href.split("#")[1]).offset().top - 72
            );
          } catch (e) {}
        }
      }, 250);
    }
  }

  render() {
    return (
      <div style={{ height: "100%" }}>
        <div id="pageBody" className="pageBody" style={{ height: "100%" }}>
          <Knowlege
            section={this.props.routeParams.section}
            article={this.props.routeParams.article}
            routeParams={this.props.routeParams}
          />
        </div>
        <SideMenu
          section={this.props.routeParams.section}
          article={this.props.routeParams.article}
          routeParams={this.props.routeParams}
        />
      </div>
    );
  }
}
export default KnowlegePage;



// WEBPACK FOOTER //
// ./src/routes/KnowlegePage/components/KnowlegePage.js